import { render } from "./SheetUI.vue?vue&type=template&id=072795c2"
import script from "./SheetUI.vue?vue&type=script&lang=js"
export * from "./SheetUI.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Documents\\Github\\OpticTool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__